import React, { useEffect, useState } from 'react';
import Grid from '../../../Grid';
import styles from './../OrderTable/Cards.module.sass';

const Cards = () => {
  const [counts, setCounts] = useState([]);

  useEffect(() => {
    const fetchCounts = async () => {
      let response = await fetch('/admin/work_orders/counts')
      response = await response.json()
      setCounts(response.data)
    }

    fetchCounts();
  }, [])

  return (
    <div className={styles.cardsContainer}>
      <Grid container>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count} href="/admin/work_orders?q%5Bwork_order_type_eq=Award&q%5Bcompleted_eq=false" target="_blank">
            {counts && counts.award}
          </a>
          <p className={styles.cardInfo}>
            Open Award WO
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count} href="/admin/work_orders?q%5Bwork_order_type_eq=Class+Picture&q%5Bcompleted_eq=false" target="_blank">
            {counts && counts.class_picture}
          </a>
          <p className={styles.cardInfo}>
            Open Class Picture WO
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count} href="/admin/work_orders?q%5Bwork_order_type_eq=ID+Card+(for+student)&q%5Bcompleted_eq=false" target="_blank">
            {counts && counts.id_card}
          </a>
          <p className={styles.cardInfo}>
            Open ID Card WO
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count} href="/admin/work_orders?q%5Bwork_order_type_eq=Locate+Image+File&q%5Bcompleted_eq=false" target="_blank">
            {counts && counts.locate_image_file}
          </a>
          <p className={styles.cardInfo}>
            Open Locate Image File WO
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count} href="/admin/work_orders?q%5Bwork_order_type_eq=Process+Image+File&q%5Bcompleted_eq=false" target="_blank">
            {counts && counts.process_image_file}
          </a>
          <p className={styles.cardInfo}>
            Open Process Image File WO
          </p>
        </Grid>
      </Grid>

      <Grid container>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count} href="/admin/work_orders?q%5Bwork_order_type_eq=Name+Wallets&q%5Bcompleted_eq=false" target="_blank">
            {counts && counts.name_wallets}
          </a>
          <p className={styles.cardInfo}>
            Open Name Wallets WO
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count} href="/admin/work_orders?q%5Bwork_order_type_eq=Package&q%5Bcompleted_eq=false" target="_blank">
            {counts && counts.package}
          </a>
          <p className={styles.cardInfo}>
            Open Package WO
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count} href="/admin/work_orders?q%5Bwork_order_type_eq=Refund&q%5Bcompleted_eq=false" target="_blank">
            {counts && counts.refund}
          </a>
          <p className={styles.cardInfo}>
            Open Refund WO
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count} href="/admin/work_orders?q%5Bwork_order_type_eq=Senior&q%5Bcompleted_eq=false" target="_blank">
            {counts && counts.senior}
          </a>
          <p className={styles.cardInfo}>
           Open Senior WO
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count} href="/admin/work_orders?q%5Bshipped_24_hours=true" target="_blank">
            {counts && counts.shipped}
          </a>
          <p className={styles.cardInfo}>
            Shipped in the past 24 hours
          </p>
        </Grid>
      </Grid>
    </div>
  );
};

export default Cards
